import { HttpContextToken } from '@angular/common/http';

export const BYPASS_AUTH_REFRESH = new HttpContextToken<boolean>(() => false);
